import DeliveryRegionRoutingCreateComponent from './delivery_region_routing.create.component';

const AUTO_SCROLL_EDGE = 40; 
const AUTO_SCROLL_STEP = 14; 

function startAutoScroll(container, direction) {
    if (container._ruleAutoScrollDirection === direction) return;
    stopAutoScroll(container);
    container._ruleAutoScrollDirection = direction;
    container._ruleAutoScrollInterval = setInterval(() => {
        container.scrollTop += direction * AUTO_SCROLL_STEP;
    }, 16);
}

function stopAutoScroll(container) {
    if (container._ruleAutoScrollInterval) {
        clearInterval(container._ruleAutoScrollInterval);
        container._ruleAutoScrollInterval = null;
        container._ruleAutoScrollDirection = null;
    }
}

function ruleAssignmentDraggableDirective() {
    return {
        restrict: 'A',
        scope: {
            onDragStart: '&',
            onDragOver: '&',
            onDrop: '&',
            onDragEnd: '&',
            dragDisabled: '<?'
        },
        link(scope, element) {
            const node = element[0];
            const syncDraggableState = () => {
                node.setAttribute('draggable', scope.dragDisabled ? 'false' : 'true');
            };

            syncDraggableState();
            scope.$watch('dragDisabled', syncDraggableState);

            const handleDragStart = (event) => {
                if (scope.dragDisabled) {
                    event.preventDefault();
                    return;
                }
                if (event.dataTransfer) {
                    event.dataTransfer.effectAllowed = 'move';
                    try {
                        event.dataTransfer.setData('text/plain', 'rule-assignment');
                    } catch (e) {
                        
                    }
                }
                scope.$applyAsync(() => scope.onDragStart({ $event: event }));
            };

            const handleDragOver = (event) => {
                if (scope.dragDisabled) return;
                event.preventDefault();
                if (event.dataTransfer) {
                    event.dataTransfer.dropEffect = 'move';
                }

                const scrollContainer = node.closest('.zone-rule-rows-scroll');
                if (scrollContainer) {
                    const rect = scrollContainer.getBoundingClientRect();
                    if (event.clientY - rect.top < AUTO_SCROLL_EDGE) {
                        startAutoScroll(scrollContainer, -1);
                    } else if (rect.bottom - event.clientY < AUTO_SCROLL_EDGE) {
                        startAutoScroll(scrollContainer, 1);
                    } else {
                        stopAutoScroll(scrollContainer);
                    }
                }

                scope.$applyAsync(() => scope.onDragOver({ $event: event }));
            };

            const handleDrop = (event) => {
                const scrollContainer = node.closest('.zone-rule-rows-scroll');
                if (scrollContainer) stopAutoScroll(scrollContainer);

                if (scope.dragDisabled) return;
                event.preventDefault();
                scope.$applyAsync(() => scope.onDrop({ $event: event }));
            };

            const handleDragEnd = (event) => {
                const scrollContainer = node.closest('.zone-rule-rows-scroll');
                if (scrollContainer) stopAutoScroll(scrollContainer);

                scope.$applyAsync(() => scope.onDragEnd({ $event: event }));
            };

            node.addEventListener('dragstart', handleDragStart);
            node.addEventListener('dragover', handleDragOver);
            node.addEventListener('drop', handleDrop);
            node.addEventListener('dragend', handleDragEnd);

            scope.$on('$destroy', () => {
                node.removeEventListener('dragstart', handleDragStart);
                node.removeEventListener('dragover', handleDragOver);
                node.removeEventListener('drop', handleDrop);
                node.removeEventListener('dragend', handleDragEnd);

                const scrollContainer = node.closest('.zone-rule-rows-scroll');
                if (scrollContainer) stopAutoScroll(scrollContainer);
            });
        }
    };
}

function ruleAssignmentLoadMoreSentinelDirective() {
    return {
        restrict: 'A',
        scope: {
            onLoadMore: '&',
            scrollDisabled: '<?'
        },
        link(scope, element) {
            const node = element[0];
            const scrollRoot = node.closest('.zone-rule-rows-scroll') || null;
            let observer = null;

            const disconnect = () => {
                if (observer) {
                    observer.disconnect();
                    observer = null;
                }
            };

            const connect = () => {
                if (observer || scope.scrollDisabled) return;
                observer = new IntersectionObserver((entries) => {
                    if (entries.some((entry) => entry.isIntersecting)) {
                        scope.$applyAsync(() => scope.onLoadMore());
                    }
                }, { root: scrollRoot, rootMargin: '100px' });
                observer.observe(node);
            };

            scope.$watch('scrollDisabled', (disabled) => {
                if (disabled) disconnect();
                else connect();
            });

            scope.$on('$destroy', disconnect);
        }
    };
}

const DeliveryRegionRoutingCreateModule = angular.module('deliveryRegionRoutingCreate', [])
    .directive('ruleAssignmentDraggable', ruleAssignmentDraggableDirective)
    .directive('ruleAssignmentLoadMoreSentinel', ruleAssignmentLoadMoreSentinelDirective)
    .component('deliveryRegionRoutingCreate', DeliveryRegionRoutingCreateComponent)
    .name;

export default DeliveryRegionRoutingCreateModule;



// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/create/index.js